import React, { Component } from 'react';
import { Navbar, Nav, Form, FormControl, Button, Container } from 'react-bootstrap';
import { FaShoppingCart, FaBell, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';

class NavBar2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
      dropdownOpen: false,
    };
  }

  handleLogout = () => {
    // Utilisation de navigate si nécessaire
    this.props.navigate('/');
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  render() {
    const { isHovered, dropdownOpen } = this.state;
    const buttonStyle = {
      color: isHovered ? 'white' : '#9caf7d',
      borderColor: isHovered ? '#C62E2E' : '#9caf7d',
      backgroundColor: isHovered ? '#C62E2E' : 'transparent',
      marginLeft: '250px',
    };

    return (
      <Navbar
        bg="light"
        variant="light"
        expand="lg"
        style={{
          padding: '0.2rem 1rem',
          marginLeft: '-50px',
          boxShadow: '1px 2px 9px 0 gray',
          height:'80px'
        }}
      >
        <Container>
          <Link to="/" className="navbar-brand">
            <img
              src={`${process.env.PUBLIC_URL}/logoWhite.png`}
              alt="Logo"
              style={{
                width: '270px',
                height: '70px',
                marginLeft: '-130px',
              }}
            />
          </Link>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            {/* Barre de recherche */}
            <Form className="d-flex" style={{ flexGrow: 1 }}>
              <FormControl
                type="text"
                placeholder="Rechercher un produit .."
                className="mr-sm-2"
                style={{
                  borderRadius: '6px 0px 0px 6px',
                  width: '340px',
                  height: '38px',
                }}
              />
              <Button
                variant="outline-success"
                type="submit"
                style={{
                  borderRadius: '0px 6px 6px 0px',
                  backgroundColor: '#9caf7d',
                  color: 'white',
                  border: 'none',
                  height: '38px',
                  marginLeft: '-5px',
                  marginTop: '0px',
                }}
              >
                Rechercher
              </Button>
            </Form>

            {/* Liens de navigation */}
            <Nav className="ml-auto d-flex align-items-center">
              <Link to="/CartComponent" className="nav-link">
                <FaShoppingCart size={18} className="me-2" />
              </Link>

              <div className="nav-link" onClick={this.toggleDropdown} style={{ cursor: 'pointer' }}>
                <FaUser size={18} />
              </div>

              {dropdownOpen && (
                <div
                  style={{
                    position: 'absolute',
                    backgroundColor: 'white',
                    zIndex: 1000,
                    marginTop: '50px',
                    padding: '10px',
                    border: '1px solid gray',
                    borderRadius: '5px',
                  }}
                >
                  <Link to="/profile" className="nav-link" style={{ color: 'gray' }}>
                    Profile
                  </Link>
                  <Link to="/" className="nav-link" style={{ color: 'gray' }} onClick={this.handleLogout}>
                    Se déconnecter
                  </Link>
                </div>
              )}

              <Nav.Link as={Link} to="#notifications" style={{ padding: '0.2rem' }}>
                <FaBell size={18} className="me-2" />
              </Nav.Link>
            </Nav>

            {/* Bouton d'ajout d'article */}
            <Button
              variant="outline-success"
              style={buttonStyle}
              onMouseEnter={() => this.setState({ isHovered: true })}
              onMouseLeave={() => this.setState({ isHovered: false })}
            >
              <Link
                className="nav-link"
                to="/vendre"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                + Je vends un article
              </Link>
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default NavBar2;
